import React, { useState, useRef, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import SendIcon from "@material-ui/icons/ArrowUpwardRounded";
import ArrowFwdIcon from "@material-ui/icons/ArrowForwardRounded";
import SeedCallIcon from "@material-ui/icons/PhoneInTalkOutlined";
import SeedHotIcon from "@material-ui/icons/WhatshotOutlined";
import SeedQaIcon from "@material-ui/icons/QuestionAnswerOutlined";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import { useProject } from "../../context/Project/ProjectContext";

// voz de todo agente NOVO: OpenAI GPT-Live (conversa mais natural). Agentes
// antigos sem provider gravado seguem no gemini.
const NEW_AGENT_VOICE = { provider: "gptlive", voice: "bossa" };

// "Porta" de criação de agente — mesma experiência da nova conversa: título
// grande, descreva em uma frase / clique num exemplo, e o COPILOTO de agente
// abre sobre o editor e monta o agente na frente do usuário (seed → run).
const FONT = 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

const hexA = (hex, a) => {
  const m = /^#?([0-9a-f]{6})$/i.exec(String(hex || ""));
  if (!m) return hex;
  const n = parseInt(m[1], 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${a})`;
};

const Sparkle = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M12 2.4l1.7 5.1a4 4 0 0 0 2.8 2.8l5.1 1.7-5.1 1.7a4 4 0 0 0-2.8 2.8L12 21.6l-1.7-5.1a4 4 0 0 0-2.8-2.8L2.4 12l5.1-1.7a4 4 0 0 0 2.8-2.8L12 2.4z" />
    <path d="M5 3.2l.6 1.8a1.4 1.4 0 0 0 1 1l1.8.6-1.8.6a1.4 1.4 0 0 0-1 1L5 10l-.6-1.8a1.4 1.4 0 0 0-1-1L1.6 6.6l1.8-.6a1.4 1.4 0 0 0 1-1L5 3.2z" opacity=".85" />
  </svg>
);

// sementes adaptadas para AGENTES de voz
const SEEDS = [
  { icon: SeedCallIcon, color: "#2F6FB0", label: "Atender ligações e agendar meus clientes", send: "Quero um agente que atende ligações e agenda meus clientes." },
  { icon: SeedHotIcon, color: "#E0742A", label: "Qualificar leads e transferir os quentes pra mim", send: "Quero um agente que qualifica leads na ligação e transfere os quentes para um humano." },
  { icon: SeedQaIcon, color: "#1E9E62", label: "Tirar dúvidas sobre meus produtos e preços", send: "Quero um agente que tira dúvidas dos clientes sobre meus produtos e preços." },
];

const useStyles = makeStyles(theme => ({
  root: { display: "flex", flexDirection: "column", height: "100%", minHeight: 0, background: "#fff", fontFamily: FONT, position: "relative" },
  heroScroll: { flex: 1, overflowY: "auto", display: "flex", ...theme.scrollbarStyles },
  hero: { width: "100%", maxWidth: 640, margin: "auto", padding: "48px 24px", boxSizing: "border-box" },
  heroSpark: {
    width: 42, height: 42, borderRadius: 12, background: theme.app.dark,
    display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 26,
    "& svg": { fontSize: 21, color: "#CEFF00" },
  },
  heroH1: { fontFamily: FONT, fontWeight: 900, fontSize: 34, letterSpacing: "-0.03em", lineHeight: 1.05, color: theme.app.ink, margin: 0 },
  heroLead: { fontSize: 15.5, color: theme.app.textSecondary, margin: "12px 0 0", lineHeight: 1.5 },
  heroField: {
    display: "flex", alignItems: "flex-end", gap: 8, marginTop: 26,
    border: `1px solid ${theme.app.border}`, borderRadius: 14, padding: "10px 10px 10px 16px",
    background: "#fff", boxShadow: "0 1px 2px rgba(16,24,40,.05)",
    transition: "border-color .12s, box-shadow .12s",
    "&:focus-within": { borderColor: theme.app.dark, boxShadow: "0 0 0 3px rgba(44,53,61,.08)" },
  },
  heroTextarea: {
    flex: 1, border: "none", outline: "none", resize: "none", fontFamily: FONT,
    fontSize: 15.5, lineHeight: 1.5, color: theme.app.ink, background: "transparent",
    maxHeight: 160, padding: "7px 0", "&::placeholder": { color: theme.app.textTertiary },
  },
  heroSend: {
    flexShrink: 0, width: 42, height: 42, borderRadius: 11, border: "none",
    background: theme.app.dark, color: "#fff", display: "flex", alignItems: "center", justifyContent: "center",
    cursor: "pointer", transition: "background .12s", "&:hover": { background: "#1f262c" }, "& svg": { fontSize: 22 },
  },
  heroSendOff: { background: "#E2E4E7", color: "#A6ADB4", cursor: "default", "&:hover": { background: "#E2E4E7" } },
  seedsLabel: { fontSize: 12.5, color: theme.app.textTertiary, margin: "26px 0 10px" },
  seedList: { display: "flex", flexDirection: "column", gap: 10 },
  seedCard: {
    display: "flex", alignItems: "center", gap: 14, textAlign: "left", width: "100%",
    border: `1px solid ${theme.app.border}`, borderRadius: 14, padding: "14px 16px", background: "#fff",
    cursor: "pointer", fontFamily: FONT, transition: "border-color .12s, box-shadow .12s, transform .12s",
    "&:hover": { borderColor: "#D8DBDF", boxShadow: "0 4px 16px rgba(27,34,42,.06)" },
    "&:hover $seedArrow": { opacity: 1, transform: "none" },
  },
  seedIcon: { width: 38, height: 38, borderRadius: 10, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", "& svg": { fontSize: 21 } },
  seedText: { flex: 1, minWidth: 0, fontSize: 14.5, fontWeight: 600, color: theme.app.ink, lineHeight: 1.35 },
  seedArrow: { color: theme.app.textTertiary, flexShrink: 0, opacity: 0, transform: "translateX(-4px)", transition: "opacity .12s, transform .12s", "& svg": { fontSize: 20 } },
  heroEscape: {
    display: "block", width: "100%", textAlign: "center", marginTop: 24, padding: 8,
    background: "none", border: "none", cursor: "pointer", fontFamily: FONT,
    fontSize: 13.5, fontWeight: 500, color: theme.app.textSecondary,
    "&:hover": { color: theme.app.ink },
  },
  hint: { maxWidth: 640, margin: "0 auto", textAlign: "center", fontSize: 11.5, color: theme.app.textTertiary },

  // ---- overlay de transição (minimiza pro canto) ----
  launchOverlay: {
    position: "absolute", inset: 0, zIndex: 30, pointerEvents: "none", overflow: "hidden",
    background: "rgba(255,255,255,0.35)", animation: "$launchScrim .3s ease both",
  },
  "@keyframes launchScrim": { from: { opacity: 0 }, to: { opacity: 1 } },
  launchCard: {
    position: "absolute", left: "50%", top: "46%", width: 360, maxWidth: "84%",
    background: "#fff", border: `1px solid ${theme.app.border}`, borderRadius: 16,
    boxShadow: "0 18px 50px rgba(27,34,42,.22)", padding: 16, textAlign: "left",
    transformOrigin: "center", animation: "$dockBR 1s cubic-bezier(.4,0,.2,1) both",
  },
  "@keyframes dockBR": {
    "0%": { opacity: 0, transform: "translate(-50%,-42%) scale(.94)" },
    "12%": { opacity: 1, transform: "translate(-50%,-50%) scale(1)" },
    "56%": { opacity: 1, transform: "translate(-50%,-50%) scale(1)" },
    "70%": { opacity: 0, transform: "translate(11vw,8vh) scale(.7)" },
    "100%": { opacity: 0, transform: "translate(20vw,15vh) scale(.55)" },
  },
  launchHead: { display: "flex", alignItems: "center", gap: 10, marginBottom: 12 },
  launchSparkle: {
    width: 30, height: 30, borderRadius: 9, flexShrink: 0,
    background: theme.app.dark, display: "flex", alignItems: "center", justifyContent: "center",
    "& svg": { fontSize: 16, color: "#CEFF00" },
  },
  launchTitle: { fontSize: 13.5, fontWeight: 600, color: theme.app.textSecondary, display: "inline-flex", alignItems: "center" },
  launchBubble: {
    background: "#F1F3F6", borderRadius: 12, padding: "10px 12px",
    fontSize: 14.5, fontWeight: 500, color: theme.app.ink, lineHeight: 1.4,
  },
  dots: { display: "inline-flex", gap: 4, padding: "0 0 0 4px" },
  dot: { width: 6, height: 6, borderRadius: "50%", background: theme.app.textTertiary, animation: "$blink 1.3s infinite both" },
  "@keyframes blink": { "0%, 80%, 100%": { opacity: 0.25 }, "40%": { opacity: 1 } },
}));

const AgentHero = () => {
  const classes = useStyles();
  const history = useHistory();
  const { activeProjectId } = useProject();
  const [input, setInput] = useState("");
  const [launching, setLaunching] = useState(null);
  const busyRef = useRef(false);

  const canSend = !!input.trim() && !!activeProjectId && !launching;

  // cria o agente e transiciona pro editor com o copiloto já construindo (seed)
  const launchAgent = useCallback(
    async text => {
      const spec = (text || "").trim();
      if (!spec || busyRef.current || !activeProjectId) return;
      busyRef.current = true;
      setLaunching(spec);
      try {
        const { data } = await api.post("/applications", {
          name: "Novo agente",
          triggerType: "agent",
          triggerConfig: NEW_AGENT_VOICE,
          projectId: activeProjectId,
        });
        // segura a animação ~700ms e navega — o copiloto brota do canto e monta
        await new Promise(r => window.setTimeout(r, 700));
        history.push({ pathname: `/agents/${data.id}`, state: { openCopilot: true, seed: spec } });
      } catch (err) {
        setLaunching(null);
        busyRef.current = false;
        toastError(err);
      }
    },
    [activeProjectId, history]
  );

  // "Só explorar": cria um agente EM BRANCO e abre o editor manual (sem o copiloto
  // seedando). Sem projeto ativo, cai na lista.
  const createBlank = useCallback(async () => {
    if (busyRef.current) return;
    if (!activeProjectId) {
      history.push("/agents");
      return;
    }
    busyRef.current = true;
    try {
      const { data } = await api.post("/applications", {
        name: "Novo agente",
        triggerType: "agent",
        triggerConfig: NEW_AGENT_VOICE,
        projectId: activeProjectId,
      });
      history.push(`/agents/${data.id}`);
    } catch (err) {
      busyRef.current = false;
      toastError(err);
    }
  }, [activeProjectId, history]);

  const onKeyDown = e => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (canSend) launchAgent(input);
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.heroScroll}>
        <div className={classes.hero}>
          <div className={classes.heroSpark}><Sparkle /></div>
          <h1 className={classes.heroH1}>O que seu agente vai atender?</h1>
          <p className={classes.heroLead}>Descreva em uma frase — eu monto o agente na sua frente, sem você configurar nada agora.</p>
          <div className={classes.heroField}>
            <textarea
              className={classes.heroTextarea}
              placeholder="Ex.: atender ligações e agendar meus clientes"
              rows={1}
              value={input}
              onChange={e => setInput(e.target.value)}
              onKeyDown={onKeyDown}
              autoFocus
            />
            <button
              type="button"
              className={`${classes.heroSend} ${canSend ? "" : classes.heroSendOff}`}
              onClick={() => launchAgent(input)}
              disabled={!canSend}
              aria-label="Montar agente"
            >
              <SendIcon />
            </button>
          </div>
          <div className={classes.seedsLabel}>Ou comece por um destes:</div>
          <div className={classes.seedList}>
            {SEEDS.map(s => (
              <button key={s.label} type="button" className={classes.seedCard} onClick={() => launchAgent(s.send)}>
                <span className={classes.seedIcon} style={{ background: hexA(s.color, 0.12), color: s.color }}>
                  <s.icon />
                </span>
                <span className={classes.seedText}>{s.label}</span>
                <span className={classes.seedArrow}><ArrowFwdIcon /></span>
              </button>
            ))}
          </div>
          <button type="button" className={classes.heroEscape} onClick={createBlank}>
            Só explorar por enquanto →
          </button>
        </div>
      </div>
      <div className={classes.hint} style={{ padding: "0 24px 16px" }}>O copiloto pode cometer erros. Revise a configuração do agente antes de publicar.</div>

      {launching ? (
        <div className={classes.launchOverlay}>
          <div className={classes.launchCard}>
            <div className={classes.launchHead}>
              <span className={classes.launchSparkle}><Sparkle /></span>
              <span className={classes.launchTitle}>
                Montando seu agente
                <span className={classes.dots}>
                  <span className={classes.dot} /><span className={classes.dot} style={{ animationDelay: ".15s" }} /><span className={classes.dot} style={{ animationDelay: ".3s" }} />
                </span>
              </span>
            </div>
            <div className={classes.launchBubble}>{launching}</div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default AgentHero;
